export default "__VITE_ASSET__Ct1m$jAI__"